"use client";

import { Skeleton } from "../ui/skeleton";

const CardSkeleton = () => {
    return (
        <div
            className="rounded-lg overflow-hidden border border-gray-100 bg-white"
        >
            {/* Feature Image Skeleton */}
            <div className="w-full h-32 sm:h-40 md:h-48 relative">
                <Skeleton className="w-full h-full" />
                {/* Badge Skeleton */}
                <Skeleton className="absolute top-2 left-2 h-5 w-16 rounded-full" />
            </div>

            <div className="p-2 space-y-2">
                {/* Title Skeleton */}
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-3/4" />

                {/* Excerpt Skeleton (optional, small) */}
                <Skeleton className="h-3 w-5/6 mt-2" />

                {/* Date/Meta Skeleton */}
                <div className="flex items-center pt-2">
                    <Skeleton className="h-3 w-3 rounded-full mr-2" />
                    <Skeleton className="h-3 w-20" />
                </div>

                {/* Button Skeleton */}
                <div className="flex items-center pt-2 border-t border-gray-100 mt-2">
                    <Skeleton className="h-3 w-20" />
                    <Skeleton className="h-3 w-3 ml-2" />
                </div>
            </div>
        </div>
    );
};

export default CardSkeleton;
